const INDIA_TIMEZONES = new Set(["Asia/Kolkata", "Asia/Calcutta"]);
const US_TIMEZONE_PREFIXES = ["America/"];

export function detectCountryCode() {
  // The device timezone is a better location signal than the browser language.
  // For example, many users in India keep an en-US browser locale.
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
  if (INDIA_TIMEZONES.has(timezone)) return "IN";
  if (US_TIMEZONE_PREFIXES.some((prefix) => timezone.startsWith(prefix))) return "US";

  const languages = navigator.languages?.length ? navigator.languages : [navigator.language];
  for (const language of languages.filter(Boolean)) {
    try {
      const region = new Intl.Locale(language).region;
      if (region) return region.toUpperCase();
    } catch {
      // Older browsers may not expose Intl.Locale; timezone fallback remains available.
    }
  }

  return null;
}

export function formatMoney(amountMinor, currency = "INR") {
  return new Intl.NumberFormat(undefined, {
    style: "currency",
    currency,
    minimumFractionDigits: amountMinor % 100 === 0 ? 0 : 2,
  }).format(amountMinor / 100);
}
